import { useMutation } from "urql";

import { CreatePaymasterDocument } from "../../../graphql/generated.ts";

export function useCreatePaymaster() {
  return useMutation(CreatePaymasterDocument);
}
